import { render, staticRenderFns } from "./DashboardAnnouncement.vue?vue&type=template&id=34e67728&"
import script from "./DashboardAnnouncement.vue?vue&type=script&lang=js&"
export * from "./DashboardAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAnnouncement.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports